import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "template-registry-api"
    }}>{`Template Registry API`}</h1>
    <h2 {...{
      "id": "authentication"
    }}>{`Authentication`}</h2>
    <p>{`A valid Adobe IMS access token is required for `}<inlineCode parentName="p">{`POST`}</inlineCode>{` and `}<inlineCode parentName="p">{`DELETE`}</inlineCode>{` actions.`}</p>
    <h2 {...{
      "id": "authorization"
    }}>{`Authorization`}</h2>
    <ul>
      <li parentName="ul">{`Admin: is a member of an Adobe IMS organization listed in the `}<inlineCode parentName="li">{`ADMIN_IMS_ORGANIZATIONS`}</inlineCode>{` environment variable`}
        <ul parentName="li">
          <li parentName="ul">{`All API endpoints are available.`}</li>
          <li parentName="ul">{`Can manage all App Builder templates in Template Registry.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`Developer: an authenticated Adobe customer`}
        <ul parentName="li">
          <li parentName="ul">{`May add or search templates`}</li>
          <li parentName="ul"><inlineCode parentName="li">{`DELETE`}</inlineCode>{` action is unavailable`}</li>
        </ul>
      </li>
    </ul>
    <h2 {...{
      "id": "summary-of-endpoints"
    }}>{`Summary of Endpoints`}</h2>
    <p>{`Use the `}<a parentName="p" {...{
        "href": "/app-builder-template-registry/api/index.md"
      }}>{`Swagger UI`}</a>{` to see endpoint summaries, available methods, parameters, example values, models, and status codes, and to try out the API.`}</p>
    <h4 {...{
      "id": "base-url"
    }}>{`Base URL`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Environment`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`URL`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Prod`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://360030-templateregistryapi.adobeioruntime.net"
            }}>{`https://360030-templateregistryapi.adobeioruntime.net`}</a></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Stage`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><a parentName="td" {...{
              "href": "https://360030-templateregistryapi-stage.adobeioruntime.net"
            }}>{`https://360030-templateregistryapi-stage.adobeioruntime.net`}</a></td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "endpoints"
    }}>{`Endpoints`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Action`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Path`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`HTTP status code`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Get list of templates`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`/apis/v1/templates`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`200, 400, 500, 503, 504`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Add template`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`POST`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`/apis/v1/templates`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`200, 400, 401, 403, 409, 500, 503, 504`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Delete tempalate`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`DELETE`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`/apis/v1/templates/{template-name}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`200, 400, 401, 403, 404, 500, 503, 504`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Retrieve template by name`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`GET`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`/apis/v1/templates/{template-name}`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`200, 400, 404, 500, 503, 504`}</td>
        </tr>
      </tbody>
    </table>
    <h3 {...{
      "id": "search--filtering"
    }}>{`Search & Filtering`}</h3>
    <h4 {...{
      "id": "search"
    }}>{`Search`}</h4>
    <p>{`The `}<inlineCode parentName="p">{`GET /apis/v1/templates`}</inlineCode>{` endpoint supports search for templates using the following query parameters:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Key`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`names`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`list of strings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter by template names.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`categories`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`list of strings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter by template categories.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`statuses`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`list of strings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter by template statuses (TEMPLATE_STATUS_IN_VERIFICATION, TEMPLATE_STATUS_APPROVED, TEMPLATE_STATUS_REJECTED).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`apis`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`list of strings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter by template APIs. Supports EMPTY and ANY filters.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`extensions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`list of strings`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter by template extension points. Supports EMPTY and ANY filters.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`events`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`EMPTY and ANY filters only`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Filter by template events. For now supports EMPTY and ANY filters only.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`runtime`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Is Adobe I/O Runtime required or not? Supports EMPTY and ANY filters.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`adobeRecommended`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`boolean`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Indicates templates featured by Adobe.`}</td>
        </tr>
      </tbody>
    </table>
    <h4 {...{
      "id": "filtering"
    }}>{`Filtering`}</h4>
    <p>{`Additionaly, the following filtering operators are supported:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Filter Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Value`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`EMPTY (NONE)`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`'', an empty string`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returns all templates that don't have a property set.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ANY`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`*, an asterisk symbol`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Returns all templates that have a property set.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`NOT`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`!, an exclamation point symbol`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Excludes all templates which contain the negated query parameter value.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`OR`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`|`}{`, a pipe symbol`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Array filters, e.g.: `}<inlineCode parentName="td">{`categories`}</inlineCode>{`, default to returning the intersection (AND) of all matching templates. This filter operator adds the ability to specify a logical "OR" for individual values.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`By default, the `}<inlineCode parentName="p">{`GET /apis/v1/templates`}</inlineCode>{` endpoint returns templates that match all of the specified criteria, implicitly `}<inlineCode parentName="p">{`AND`}</inlineCode>{`ing all the terms of the search. For example, if you specify `}<inlineCode parentName="p">{`names`}</inlineCode>{` and `}<inlineCode parentName="p">{`categories`}</inlineCode>{` query parameters, the endpoint returns templates that match both criteria. If you want to return templates that match any of the specified criteria, use the `}<inlineCode parentName="p">{`OR`}</inlineCode>{` filter operator. This will group all the `}<inlineCode parentName="p">{`OR`}</inlineCode>{`ed values and evalute them first, then `}<inlineCode parentName="p">{`AND`}</inlineCode>{` the results with the rest of the query parameters.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      